// extracted by mini-css-extract-plugin
module.exports = {"image":"words-about-wallpaintings-module--image--3NmNf"};